import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-drivers-modal-roundup',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule],
	templateUrl: './drivers-modal-confirmation.component.html',
})
export class DriversModalConfirmationComponent {
	readonly dialogRef = inject(MatDialogRef<DriversModalConfirmationComponent>);

	close(roundFinalSum: boolean): void {
		this.dialogRef.close(roundFinalSum);
	}
}
